export default __webpack_public_path__ + "static/media/black-tip-icon.2c5d92ad.svg";